// Pagina de autentificacion/login
import{ useState} from 'react';
import { auth } from '../../firebase/config';
import { 
    signInWithEmailAndPassword
} from 'firebase/auth';

export const AuthPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try { 
            await signInWithEmailAndPassword(auth, email, password); 
        } catch (err) { 
            setError("Email o contraseña incorrectos."); 
        }
    };
    
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#cdcdcd]">
            <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-2xl">
                <img src="https://www.grupoevelsa.com/assets/images/Logo Evelsa 2.png" alt="Logo Grupo Evelsa" className="h-16 mx-auto mb-6"/>
                <h2 className="text-2xl font-bold text-center text-gray-800 mb-8">Acceso al Portal</h2>
                <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Email</label>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm"/>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Contraseña</label>
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm"/>
                    </div>
                    {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                    <button type="submit" className="w-full bg-[#b0ef26] hover:bg-[#9ac91e] text-black font-bold py-3 px-4 rounded-lg transition duration-300 text-lg">
                        Entrar
                    </button>
                </form>
            </div>
        </div>
    );
};